module.exports = "query GetBasicPostageCosts {\n  nationalBasicPostageCost\n  internationalBasicPostageCost\n}\n"